<template>
  <div>
    <div
      class="floor-coupon-img"
      v-if="contentInfo.images[0]"
      @click="getCoupon"
    >
      <img
        class="img"
        v-show="couponInfo.status === 1"
        :src="contentInfo.images[0]"
        alt=""
      />
      <img
        class="img"
        v-show="couponInfo.status === 2"
        :src="contentInfo.images[1]"
        alt=""
      />
      <img
        class="img"
        v-show="couponInfo.status === 0"
        :src="contentInfo.images[2]"
        alt=""
      />
    </div>
    <div class="floor-coupon-wrap" v-else>
      <div
        class="floor-coupon-box"
        @click="getCoupon"
        :class="{ gray: couponInfo.status === 0, get: couponInfo.status === 2 }"
      >
        <div style="overflow: hidden">
          <div class="floor-coupon">
            <div class="floor-coupon-value">
              <div
                class="floor-coupon-value-center"
                v-if="couponInfo.coupon_type === 3"
              >
                ￥<span>{{ couponInfo.cash_reduce / 100 }}</span>
              </div>
              <div
                class="floor-coupon-value-center"
                v-if="couponInfo.coupon_type === 0"
              >
                <span>{{ couponInfo.discount_rate / 10 }}</span
                >折
              </div>
            </div>
            <div class="floor-coupon-info">
              <div class="floor-coupon-info-reach">
                <div v-if="couponInfo.reach_reduce === 0">无使用限制</div>
                <div v-else>满 {{ couponInfo.reach_reduce / 100 }} 可用</div>
              </div>
              <div class="floor-coupon-info-max" v-if="couponInfo.limit_desc">
                {{ couponInfo.limit_desc }}
              </div>
              <div
                class="floor-coupon-info-date"
                v-if="couponInfo.validity_type === 1"
              >
                领取后{{ couponInfo.validity }}天内有效
              </div>
              <div class="floor-coupon-info-date" v-else>
                {{ couponInfo.start_date }} 至 {{ couponInfo.end_date }}
              </div>
              <div class="floor-coupon-info-scope">
                {{ couponInfo.scope }}
                <img
                  v-if="couponInfo.scope_desc"
                  @click.stop.prevent="openScope(couponInfo.scope_desc)"
                  class="icon"
                  src="../../../assets/imgs/tips_icon.png"
                />
              </div>
            </div>
            <div class="floor-coupon-status">
              <div class="floor-coupon-status-box">
                <span class="label" v-if="couponInfo.status === 1"
                  >点击领取</span
                >
                <span class="label" v-if="couponInfo.status === 2">已领取</span>
                <span class="label" v-if="couponInfo.status === 0">抢光了</span>
              </div>
            </div>
          </div>
        </div>
        <div @click.stop.prevent="() => {}">
          <CommonDialog v-model="scopeInfo.visible" :title="scopeInfo.nowTitle">
            <div>
              <ul class="coupon-scope-list">
                <li
                  class="coupon-scope-list-item"
                  v-for="(item, index) in scopeInfo.dataArr"
                  :key="index"
                >
                  {{ item }}
                </li>
              </ul>
            </div>
          </CommonDialog>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import activityToast from '../activity-toast.js';
import CommonDialog from './common-dialog';

export default {
  name: 'floor-coupon',
  components: {
    CommonDialog,
  },
  data() {
    return {
      scopeInfo: {
        visible: false,
        dataArr: [],
        nowTitle: '',
      },
    };
  },
  props: {
    contentInfo: Object,
  },
  computed: {
    couponInfo() {
      return this.contentInfo.coupon_info;
    },
  },
  methods: {
    getCoupon() {
      if (this.couponInfo.status === 1) {
        this.$emit('get-coupon', this.couponInfo.code, this.couponInfo);
      }
    },
    openScope(arr) {
      this.scopeInfo.dataArr = arr.split('\n');
      this.scopeInfo.nowTitle = this.scopeInfo.dataArr[0];
      this.scopeInfo.dataArr.shift();
      this.scopeInfo.visible = true;
    },
  },
};
</script>
<style lang="less" scoped>
.floor-coupon-img {
  width: 100%;
  font-size: 0;
  .img {
    width: 100%;
  }
}
.floor-coupon-wrap {
  padding: 0.05rem 0.1rem;
}
.floor-coupon-box {
  box-shadow: 0rem 0.01rem 0.08rem 0rem rgba(0, 0, 0, 0.1);
  width: 100%;
  box-sizing: border-box;
  background: #f5eede;
  border-radius: 0.03rem;
  padding: 0.05rem;
  .floor-coupon {
    border: solid 1px #ff5a60;
    border-radius: 0.03rem;
    box-sizing: border-box;
    display: flex;
    .floor-coupon-value {
      display: flex;
      align-items: center;
      justify-content: center;
      .floor-coupon-value-center {
        width: 1.2rem;
        color: #ff5a60;
        font-size: 0.18rem;
        font-weight: 600;
        text-align: center;
        span {
          font-size: 0.36rem;
          letter-spacing: -2px;
        }
      }
    }
    .floor-coupon-info {
      flex-grow: 1;
      line-height: 1;
      padding: 0.12rem 0 0.11rem 0.05rem;
      .floor-coupon-info-reach {
        font-size: 0.15rem;
        color: #444;
        padding-bottom: 0.04rem;
      }
      .floor-coupon-info-max {
        font-size: 0.11rem;
        color: #d3b28b;
        border: 1px solid #d3b28b;
        border-radius: 0.03rem;
        padding: 0.03rem 0.05rem;
        display: inline-block;
        box-sizing: border-box;
      }
      .floor-coupon-info-date {
        margin-top: 0.09rem;
        color: #aaaaaa;
        font-size: 0.12rem;
        margin-bottom: 0.06rem;
      }
      .floor-coupon-info-scope {
        color: #aaaaaa;
        font-size: 0.12rem;
        display: flex;
        align-items: center;
        .icon {
          width: 0.12rem;
          height: 0.12rem;
          margin-left: 0.05rem;
        }
      }
    }
    .floor-coupon-status {
      width: 0.46rem;
      display: flex;
      align-items: center;
      position: relative;
      &::before {
        box-sizing: border-box;
        content: '';
        background: #f5eede;
        position: absolute;
        width: 0.1rem;
        height: 0.1rem;
        border-radius: 50%;
        border: 1px solid #ff5a60;
        top: -0.05rem;
        left: -0.05rem;
      }
      &::after {
        box-sizing: border-box;
        content: '';
        background: #f5eede;
        position: absolute;
        width: 0.1rem;
        height: 0.1rem;
        border-radius: 50%;
        border: 1px solid #ff5a60;
        bottom: -0.05rem;
        left: -0.05rem;
      }
      .floor-coupon-status-box {
        height: 70%;
        width: 100%;
        border-left: 1px dashed #ff5a60;
        display: flex;
        align-items: center;
        justify-content: center;
        .label {
          display: inline-block;
          width: 0.14rem;
          font-size: 0.14rem;
          color: #ff5a60;
          font-weight: 600;
        }
      }
    }
  }
}
.floor-coupon-box.gray {
  .floor-coupon-value-center,
  .floor-coupon-info-reach,
  .floor-coupon-info-max,
  .floor-coupon-info-date,
  .floor-coupon-info-scope,
  .floor-coupon-status-box .label {
    color: #cfcfcf !important;
  }
  .floor-coupon {
    border: 1px solid #cfcfcf !important;
  }
  .floor-coupon-info-max {
    border: 1px solid #cfcfcf !important;
  }
  .floor-coupon-status-box {
    border-left: 1px dashed #cfcfcf !important;
  }
  .floor-coupon-status {
    &::after,
    &::before {
      border: 1px solid #cfcfcf !important;
    }
  }
}
.floor-coupon-box.get {
  .floor-coupon {
    border: 1px solid rgba(255, 90, 96, 0.5) !important;
  }
  .floor-coupon-status-box {
    border-left: 1px dashed rgba(255, 90, 96, 0.5) !important;
    .label {
      color: rgba(255, 90, 96, 0.5) !important;
    }
  }
  .floor-coupon-status {
    &::after,
    &::before {
      border: 1px solid rgba(255, 90, 96, 0.5) !important;
    }
  }
}
.coupon-scope-list {
  max-height: 2.6rem;
  overflow: auto;
  text-align: left;
  padding: 0 0.1rem;
  .coupon-scope-list-item {
    font-size: 0.14rem;
    line-height: 0.22rem;
    list-style: disc;
    color: #6f6f6f;
    list-style-position: inside;
  }
}
</style>
